import { useEffect } from "react";

export const useScrollToTop = (deps: unknown[]) => {
  useEffect(() => {
    const id = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    });

    return () => clearTimeout(id);
  }, deps);
};
